import { render, staticRenderFns } from "./View3.vue?vue&type=template&id=0354ad34"
import script from "./View3.vue?vue&type=script&lang=js"
export * from "./View3.vue?vue&type=script&lang=js"
import style0 from "./View3.vue?vue&type=style&index=0&id=0354ad34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports